import { render, staticRenderFns } from "./jp-checkout.vue?vue&type=template&id=84ba021e&"
import script from "./jp-checkout.vue?vue&type=script&lang=js&"
export * from "./jp-checkout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports